import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import * as AccessorialInventoryActions from '@ruby/modules/accessorial-inventory/store/actions/accessorial-inventory.actions';
import * as fromAccessorialInventory from '@ruby/modules/accessorial-inventory/store/reducers/accessorial-inventory.reducer';
import * as AccessorialInventorySelectors from '@ruby/modules/accessorial-inventory/store/selectors/accessorial-inventory.selectors';
import { EInventoryRoute } from '@ruby/shared/enums/inventory-management.enums';
import { IGridPrintTitle } from '@ruby/shared/models/commons/grid.interface';

@Component({
  selector: 'ng-lease-track-overage-container',
  templateUrl: './lease-track-overage.container.html',
  styleUrls: ['./lease-track-overage.container.scss']
})
export class LeaseTrackOverageContainer {
  @Input() printTitle!: IGridPrintTitle;
  @Input() type?: EInventoryRoute;
  store$: Observable<fromAccessorialInventory.State>;

  constructor(private store: Store<fromAccessorialInventory.State>) {
    this.store$ = this.store.select(AccessorialInventorySelectors.selectAccessorialInventoryState);
  }

  /**
   * Dispatch
   *
   * @summary Dispatch an Reset Lease Track action
   * @returns void
   */
  dispatch(): void {
    this.store.dispatch(AccessorialInventoryActions.resetLeaseTrack());
  }
}
